import { useSelector } from "react-redux"
import { rattingCommentSelector } from "redux/selector"
import RattingCommentItem from "../RattingCommentItem"
import { RattingListWrapper } from "./styled"

const RattingList = ({ callBack }) => {
    const rattingState = useSelector(rattingCommentSelector)
    return (
        <RattingListWrapper>
            {
                rattingState.rattingData.length > 0 &&
                <ul className="ratting_list mx-0 px-0">
                    {
                        rattingState.rattingData.map((item, index) => (
                            !item.parent_id &&
                            <li key={index} className="ratting_item bt-grey2-1 py-10">
                                <RattingCommentItem data={item} callBack={callBack} />
                            </li>
                        ))
                    }
                </ul>
            }
        </RattingListWrapper>
    )
}

export default RattingList